import React from 'react';
import {Grid} from "@mui/material";

export interface IRequiredFieldsProps {
}

export function RequiredFields(props: IRequiredFieldsProps) {

    return (
        <Grid container direction="row" spacing={8} style={{marginTop: '5px'}}>
            <Grid item xs={12} md={12}>
            <p>Alle mit <span
                style={{color: '#F00'}}>*</span> markierten
                Felder
                sind Pflichtfelder.</p>
            </Grid>
        </Grid>
    );

}